import React, { Component } from 'react';
import i18n from 'i18next'; import Button from 'react-bootstrap/lib/Button';
import HowItWorksSteps from 'components/HowItWorksSteps';
import '../motivator/PreEngagementStyles.scss';

class GoToMyReport extends Component {
    render() {
        return (
            <div className='fl-pre-engagement text-center'>
                <div className='pre-engagement-header-container'>
                    <h3>{i18n.t('engagement.great')}</h3>
                    <p>{i18n.t('motivator.step_3_check_out_your_intrinsic_motivator_report')}</p>
                </div>
                <HowItWorksSteps selectedStep={ 3 } />

                <Button className='fl-button' onClick={ this.handleClick }>{i18n.t('motivator.go_to_my_report')}</Button>
            </div>
        );
    }
    handleClick = async () => {
        const path = window.location.pathname.split('/');
        const motivatorToken = path[path.length - 1];

        window.location.href = `${ process.env.ATTUNED_URL }/report/motivator/${ motivatorToken }?newuser=true`;
    };
}


export default GoToMyReport;
